<!-- <div id="wifiFeatures">
    <ul class="center-banner-wrap">
        <li class="col medium-12 small-12 large-12">            
            <div class="wifi-feature-banner" id="netflix-banner" tabindex="0">

            </div>
        </li>
    </ul>
    </div> -->
    

<div class="container banner-height">
  <div class="row">
    <div class="col-sm-4 col-md-4">
      <a href="assets/images/banner/SAS_Inflight_onboard_summer_menu_2025.pdf" target="_blank">
      <div class="thumbnail box-height">
        <div id="foodBgImg"></div>
        <div class="teaser-info">
          <h2 class="font-24">TAKE A LOOK AT OUR MENU</h2>
        </div>
        <div class="menu-link">
          <a href="assets/images/banner/SAS_Inflight_onboard_summer_menu_2025.pdf" target="_blank">See menu</a>
        </div>
      </div>
      </a>

    </div>
    <div class="col-sm-4 col-md-4">
      <a (click)="showAnnualFeePopup()" class="cursor" target="_blank">
      <div class="thumbnail box-height">
        <div id="cardImg"></div>
        <div class="teaser-info">
          <h2 class="font-24">Travel 2 for 1</h2>
        </div>
        <div class="menu-link">
          <a (click)="showAnnualFeePopup()" class="cursor" target="_blank">Apply now</a>
        </div>
      </div>
      </a>
    </div>

    <div class="col-sm-4 col-md-4">
      <a href="https://www.flysas.com/en/destinations/" target="_blank">
      <div class="thumbnail box-height">
        <div id="travelImg"></div>
        <div class="teaser-info">
          <h2 class="font-24">WHERE WE FLY</h2>
        </div>
        <div class="menu-link">
          <a href="https://www.flysas.com/en/destinations/" target="_blank">Our destinations</a>
        </div>
      </div>
    </a>
    </div>
  </div>


  <section *ngIf="annualFeePopup">
    <div class="modal fade in feature-content-size bg-color-transparent" role="dialog" style="display: block">
      <div class="wrapper modal-data">
        <div class="modal-body">
          <div class="header-div">
            <button type="button" class="modal-close text-grey-4 modal-close-black" id="update-modal-close"
              (click)="closePopup()" tabindex="0" [attr.aria-label]="('close' | translate)"
              (keyup.enter)="closePopup()">×
            </button>

          </div>

          <div class="page-section">
            <h1 class="popup-title"> Swedish or Norwegian resident</h1>

            <div>
              <div class="radio section">
                <p class="formLabel " data-form-label="Select your residency to continue to the offer.">
                  Select your residency to continue to the offer.
                </p>
                <div class="form-row" aria-label="residency" role="radiogroup">
                  <fieldset>
                    <div class="radioButton">
                      <input role="radio" [(ngModel)]="selectedCountry" tabindex="0" aria-checked="false" data-role="none" type="radio"
                        id="residency0" name="residency" value="Norwegian">
                      <label for="residency0"><span></span>Norwegian resident</label>
                    </div>
                    <div class="radioButton">
                      <input role="radio" [(ngModel)]="selectedCountry" tabindex="0" aria-checked="false" data-role="none" type="radio"
                        id="residency1" name="residency" value="Swedish">
                      <label for="residency1"><span></span>Swedish resident</label>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div class="col-12">
                <div class="btn-inline-btm">
                  <div class="go-back">
                    <a href="#" (click)="closePopup()">Go back to SAS portal</a>
                  </div>
                  <div class="continue">
                    <a href="#continue" (click)="continue()" class="btn primary large buy-wifi-continue-button"
                    >CONTINUE</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>